import { useEffect, useState } from 'react';
import { ApiResult } from '../api/Shared';

export const tryFetchFunction =
    <ArgType, RetType>(
        fetchFunction: (arg: ArgType) => Promise<ApiResult<RetType>>,
        nullableArg?: ArgType | null,
        error?: string
    ) =>
    async () =>
        nullableArg
            ? await fetchFunction(nullableArg)
            : new Promise<ApiResult<RetType>>((resolve, _reject) => {
                  resolve({ data: undefined, success: false, error: error || 'Failed to load.' });
              });

export function useFetch<TEntity, TDefault>(
    apiMethod: () => Promise<ApiResult<TEntity>>,
    watchParams: any[],
    defaultValue: TDefault,
    fetchCondition?: boolean
) {
    const [data, setData] = useState<TEntity | TDefault>(defaultValue);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | undefined>(undefined);
    const [abort, setAbort] = useState<AbortController>();

    async function fetchUrl(abortController: AbortController) {
        setLoading(true);
        if (apiMethod) {
            const response = await apiMethod();
            if (abortController.signal.aborted) {
                // intentionally not turning loading off - this is if there's a successive request
                return;
            }
            if (response.data !== undefined) {
                setData(response.data);
            }
            setError(response.error || undefined);
        } else {
            setData(defaultValue);
        }
        setLoading(false);
    }

    useEffect(() => {
        if (fetchCondition === undefined || fetchCondition) {
            if (abort) {
                abort.abort();
            }
            let newAbort = new AbortController();
            setAbort(newAbort);
            fetchUrl(newAbort);
        }
    }, watchParams);
    return { data, loading, setData, error, setLoading, setError };
}



// WEBPACK FOOTER //
// ./src/hooks/useFetch.ts